import { useLang } from "./LangContext";
import { ChapterHead, FadeUp } from "./Reveal";

export default function About() {
  const { t } = useLang();
  const a = t.about;

  return (
    <section id="hakkinda" className="section" data-testid="about-section">
      <div className="wrap">
        <ChapterHead num={a.num} label={a.label} title={a.title} />
        <div className="about-grid">
          <div className="about-prose">
            {a.paragraphs.map((p, i) => (
              <FadeUp key={i} delay={i * 0.06}>
                <p data-testid={`about-paragraph-${i}`}>{p}</p>
              </FadeUp>
            ))}
          </div>
          <div className="about-chapters">
            {a.chapters.map((c, i) => (
              <FadeUp key={c.num} delay={i * 0.08}>
                <div className="chapter-card" data-testid={`about-chapter-${i}`}>
                  <span className="num" aria-hidden="true">
                    {c.num}
                  </span>
                  <div>
                    <h3>{c.title}</h3>
                    <p>{c.text}</p>
                  </div>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>

        <FadeUp delay={0.1}>
          <div className="frame strip about-strip" data-testid="about-strip">
            <img
              src="/img/venue-row.jpg"
              alt={a.stripAlt}
              loading="lazy"
              decoding="async"
            />
            <div className="frame-veil" aria-hidden="true" />
            <p className="strip-caption">
              <span className="diamond" aria-hidden="true">◆</span>
              {a.stripCaption}
            </p>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
